import { get } from 'lodash';

const getIsLoaded = (state: any) => state.isLoaded;

const getIsEntityLoaded = (state: any, entity: any, id = '') =>
  Boolean(id ? get(getIsLoaded(state), [entity, id]) : getIsLoaded(state)[entity]);

export const getIsCategoryLoaded = (state: any, id: any) =>
  getIsEntityLoaded(state, 'category', id);
export const getIsTagLoaded = (state: any, id: any) => getIsEntityLoaded(state, 'tag', id);
export const getIsPostLoaded = (state: any, slug: any) => getIsEntityLoaded(state, 'post', slug);
export const getIsFeedPostsLoaded = (state: any) => getIsEntityLoaded(state, 'feed-posts');
export const getIsRecentPostsLoaded = (state: any, id: any) =>
  getIsEntityLoaded(state, 'recent-posts', id);
export const getIsRelatedPostsLoaded = (state: any, id: any) =>
  getIsEntityLoaded(state, 'related-posts', id);
export const getIsPostDraftSaved = (state: any, draftKey: any) =>
  getIsEntityLoaded(state, 'postDraft', draftKey);
export const getIsArchiveLoaded = (state: any) => getIsEntityLoaded(state, 'archive');
export const getIsHashtagPostsLoaded = (state: any) => getIsEntityLoaded(state, 'hashtag-posts');
export const getIsSitePropertiesLoaded = (state: any) =>
  getIsEntityLoaded(state, 'site-properties');
export const getIsPostMetadataLoaded = (state: any) => getIsEntityLoaded(state, 'post-metadata');
export const getIsFeedMetadataLoaded = (state: any) => getIsEntityLoaded(state, 'feed-metadata');
export const getIsPostListMetadataLoaded = (state: any) =>
  getIsEntityLoaded(state, 'post-list-metadata');
